export class CommandFormatter {
    static format(command, isBinary = false) {
        let str = '';
        if (isBinary) {
            str += '[';
            for (let i = 0; i < command.length; i++) {
                if (i !== 0)
                    str += ' ';
                if (command.charCodeAt(i) < 16)
                    str += '0';
                str += (command.charCodeAt(i) & 0x00ff).toString(16);
            }
            str += ']';
        }
        else {
            for (let i = 0; i < command.length; i++) {
                const c = command.charCodeAt(i);
                if (c >= 32 && c < 127) {
                    str += command[i];
                }
                else {
                    str += '<';
                    if (c < 16)
                        str += '0';
                    str += (c & 0x00ff).toString(16) + '>';
                }
            }
        }
        return str;
    }
}
